import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  > * {
    margin: 0;
    padding: 0;
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.stroke};
  overflow-y: auto;
  border-radius: 6px;
  min-width: 550px;
  background-color: ${({ theme }) => theme.colors.cultured};

  .p-treetable-header {
    display: flex;
    align-items: center;
    height: 40px;
    padding-left: 12px;
  }

  .p-treetable {
    margin: 0;
    padding: 0;

    .p-treetable-wrapper {
      margin: 0;
      padding: 0;
    }

    table {
      margin: 0;
      padding: 0;
    }

    .p-column-header-content {
      display: flex;
      align-items: center;

      .p-column-title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .c-name {
      min-width: 26% !important;
      width: 26%;
      max-width: 400px;
    }

    .c-acc-type {
      width: 15%;
    }

    .p-treetable-thead > tr > th {
      border: none;
      color: ${({ theme }) => theme.colors.prussianBlue};
      border-top: 1px solid ${({ theme }) => theme.colors.stroke};
      padding: 0 8px 0 6px;
      height: 40px;
      font-size: 14px;
      font-weight: 600;
      user-select: none;
      text-align: left;
      margin: 0;
    }
    .p-treetable-thead > tr > th:first-child {
      padding: 0 8px 0 12px;
    }

    .p-treetable-tbody > tr {
      color: ${({ theme }) => theme.colors.prussianBlue};
      border-top: 1px solid ${({ theme }) => theme.colors.stroke};
      font-size: 13px;
      font-weight: 500;
      height: 48px;
      cursor: pointer;

      &:hover {
        background: ${({ theme }) => theme.colors.white};
      }

      &.selected-row {
        background-color: ${({ theme }) => theme.colors.aliceBlue} !important;
      }

      &.disabled-row {
        cursor: default;
        color: ${({ theme }) => theme.colors.cflowerBlue};
      }

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      > td:first-child {
        padding: 0 8px 0 12px;
      }
      > td {
        padding: 0 8px 0 6px;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    .p-treetable-toggler {
      width: 1.8rem;
      height: 1.8rem;
      margin-right: 0.4rem;
      color: ${({ theme }) => theme.colors.prussianBlue};
      position: relative;
      cursor: pointer;
      z-index: 1;

      svg {
        opacity: 0;
        position: absolute;
        pointer-events: none;
      }

      &::before {
        content: '';
        display: block;
        width: 5px;
        height: 9px;
        background-color: currentColor;
        mask: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 11"><path d="M0 0.660586L0 9.88773C0 10.0664 0.0652145 10.2208 0.195535 10.3512C0.326 10.4817 0.480415 10.5469 0.658925 10.5469C0.837435 10.5469 0.991959 10.4817 1.12235 10.3512L5.73587 5.73764C5.86634 5.60703 5.93166 5.45262 5.93166 5.27414C5.93166 5.09567 5.86634 4.94111 5.73587 4.81075L1.12231 0.197161C0.991958 0.0668401 0.837434 0.00140949 0.658888 0.0014095C0.480414 0.00140951 0.325999 0.0668039 0.195498 0.197161C0.0650696 0.327518 0 0.482077 0 0.660586Z"/></svg>')
          no-repeat center;
        -webkit-mask: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 11"><path d="M0 0.660586L0 9.88773C0 10.0664 0.0652145 10.2208 0.195535 10.3512C0.326 10.4817 0.480415 10.5469 0.658925 10.5469C0.837435 10.5469 0.991959 10.4817 1.12235 10.3512L5.73587 5.73764C5.86634 5.60703 5.93166 5.45262 5.93166 5.27414C5.93166 5.09567 5.86634 4.94111 5.73587 4.81075L1.12231 0.197161C0.991958 0.0668401 0.837434 0.00140949 0.658888 0.0014095C0.480414 0.00140951 0.325999 0.0668039 0.195498 0.197161C0.0650696 0.327518 0 0.482077 0 0.660586Z"/></svg>')
          no-repeat center;
        transition: transform 0.1s ease;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    tr[aria-expanded='false'] .p-treetable-toggler::before,
    tr:not([aria-expanded]) .p-treetable-toggler::before {
      transform: translate(-50%, -50%);
    }

    tr[aria-expanded='true'] .p-treetable-toggler::before {
      transform: translate(-50%, -50%) rotate(90deg);
    }
  }

  .c-hidden {
    display: none !important;
  }

  .c-tdm {
    width: 40px !important;
    position: relative;
  }

  .p-treetable-thead > tr > th.c-tdm {
    padding: 0 8px !important;
    text-align: center;

    .p-column-header-content {
      justify-content: center;
    }
  }

  .c-column-select {
    width: 60px !important;
    position: sticky !important;
    right: 0 !important;
    z-index: 2;
  }

  .p-treetable-thead > tr > th.c-column-select {
    z-index: 4;
    padding: 0 16px 0 0 !important;
  }

  .p-treetable-tbody > tr > td.c-column-select {
    padding: 0 16px 0 0 !important;
  }

  .p-treetable-tbody > tr:hover > td.c-column-select {
    background-color: ${({ theme }) => theme.colors.cultured};
  }
`;

export const ColumnHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: 0;

  > span:first-child {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    flex: 1;
    font-size: 14px;
  }

  > div:last-child {
    flex-shrink: 0;
    margin-left: 6px;
  }
`;
